import { configureRequest } from '@/networkRequests/apiClient/apiClient.functions'
import urls from '@/networkRequests/apiClient/endpoints'
import errorHandler from '@/shared/functions/ErrorHandler/errorHandler.functions'
import { getUserRole } from '@/shared/functions/UserRole/userRoleManagment.functions'
import { ApiErrorResponse } from '@/shared/types/api.types'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { ApiUploadPdfResponse, UploadPdfRequestPayload, UploadPdfSuccessResponse } from './uploadPdf.types'

export const uploadPdf = createAsyncThunk(
  urls.flights.uploadPdfFlightItinerary,
  async (payload: UploadPdfRequestPayload, { rejectWithValue }) => {
    try {
      const form = new FormData()
      form.append('pdf', payload.pdf)
      if (payload.offerRequestId) form.append('offerRequestId', payload.offerRequestId)

      const response = (await configureRequest({
        method: 'POST',
        url: urls.flights.uploadPdfFlightItinerary,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-User-Role': getUserRole() || ''
        },
        timeout: 60000, // 60 seconds - AI extraction can take longer than default timeout
        onUploadProgress: payload.onUploadProgress
          ? (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                payload.onUploadProgress!(percentCompleted)
              }
            }
          : undefined
      })) as ApiUploadPdfResponse<UploadPdfSuccessResponse>

      // Extract data from API response wrapper
      if (response.status >= 200 && response.status < 300) {
        payload.onSuccess?.()

        return (response.data || response) as UploadPdfSuccessResponse
      }

      throw response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, payload.onError)

      return rejectWithValue(error)
    }
  }
)
